import { Fragment, PropsWithChildren, useContext } from "react"
import { ActionButton, Button, Loading, Modal } from "../../../../../../../../../components"
import { FormSection } from "../../../../FormSection"
import * as yup from "yup"
import { FormProvider, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import toast from "react-hot-toast"
import type { DataList } from "../../../../../types"
import { useApi, useToggle } from "../../../../../../../../../utils"
import { Render } from "../../../../../utils"
import { useDetail } from "../utils"
import { menuTitle } from "./MenuTitle"
import { IsActive } from "./IsActive"

type UpdateType = {
  data?: DataList
  id: number
  toggle: () => void
  refetch: () => void
}

export function Update(props: PropsWithChildren<UpdateType>) {
  const { isActive, toggle } = useToggle(false)

  return (
    <Fragment>
      <ActionButton.Update className="join-item" onClick={toggle} />
      {isActive && <ModalSection id={props?.id} toggle={toggle} refetch={props.refetch}/>}
    </Fragment>
  )
}

export function ModalSection(props: PropsWithChildren<UpdateType>) {
  const { data, dataError, isLoading } = useDetail(props?.id)

  return (
    <Modal isOpen title={`EDIT ${menuTitle.title}`} size="xl" closeModal={props?.toggle}>
      {isLoading || dataError ? (
        <div className="p-5"><Loading errorText={dataError} loading={isLoading} /></div>
      ) : (
        <DataForm data={data!} id={props?.id} toggle={props?.toggle} refetch={props?.refetch} />
      )}
    </Modal>
  )
}

function DataForm(props: PropsWithChildren<UpdateType>) {
  const api = useApi()
  const { toggle } = useContext(Render)

  const validationSchema = yup.object().shape({
    job_position_code: yup.string().label("Job position code").required().max(3, 'Maximum code is 3 characters'),
    job_position_name: yup.string().label("Job position name").required().max(100, "Must be 100 characters or less"),
    description: yup.string().label("Description"),
    divisi_id: yup.string().label("Divisi").required(),
    kpi: yup.string().label("KPI").required(),
    qualification: yup.string().label("Qualification").required()
  })
  const onSubmit = ( value: DataList ) => {
    return new Promise<void>((resolve) => {
      toast.promise(
        api.put(`/jobposition/edit?job_position_id=${props?.id}`, 
        value
      ),
        {
          loading: "Loading...",
          success: (res) => res.data.message,
          error: (err) => err.response.data.message
        }
      ).then(() => {
        props.toggle()
        props?.refetch && props.refetch()
        toggle()
      }).catch(() => {}).finally(resolve)
    })
  }
  const methods = useForm({
    defaultValues: props?.data,
    resolver: yupResolver(validationSchema)
  })

  return (
    <FormProvider {...methods}>
      {/* @ts-ignore */}
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <Modal.Body>
          <FormSection isUpdate />
        </Modal.Body>

        <Modal.Footer className="flex justify-between gap-1">
          <IsActive data={props?.data!} refetch={props?.refetch} />
          <Button type="submit" color="primary" loading={methods.formState.isSubmitting ? "true" : undefined}>Save</Button>
        </Modal.Footer>
      </form>
    </FormProvider>
  )
}